module.exports = __webpack_public_path__ + "static/media/pressure-monitor-offline.78af5a90.svg";